const ValidationResult = function () {
    this.success = false;
    this.message = null;
};

export { ValidationResult };


// WEBPACK FOOTER //
// ./src/nams2020/webparts/Login/ValidationResult.js